<template>
    <div :class="{overlay: !customise}" v-if="!customise">
        <div class="welcome">
            <router-link :to="beforeRouteEnter.path" v-if="!complete && !ready">
                <img v-if="information || did_you_know" class="close_icon clicky" src="../../public/assets/icons/RS-PPE-ICONS-CROSS.svg" alt="" width="40">
            </router-link>
            <div v-if="first_step || current_step === 1 && !ready" v-cloak>
                <h1 class="hidden-sm hidden-xs">{{ did_you_know? dyktitle : $t('instructions.step_1.title') }}</h1>
                <h1 class="hidden-md hidden-lg">{{ did_you_know? dyktitle : $t('instructions.step_1.title_mobi') }}</h1>
                <figure class="inst_0">
                <div v-if="!did_you_know">
                    <img class="instr_0" src="../../public/assets/icons/instr_0.svg" alt="RS Components">
                    <img class="instr_1" src="../../public/assets/icons/instr_1.svg" alt="RS Components">
                    <img class="instr_2" src="../../public/assets/icons/instr_2.svg" alt="RS Components">
                    <img class="instr_3" src="../../public/assets/icons/instr_3.svg" alt="RS Components">
                </div>
                <div v-if="did_you_know">
                    {{ dykdescription }}
                </div>
                </figure>
                <p class="top_padded">{{ did_you_know? null : $t('instructions.step_1.description') }}</p>
            </div>
            <div v-if="second_step" v-cloak>
                <h1>{{ $t('instructions.step_2.title') }}</h1>
                <figure class="inst_1">
                    <img class="instr_0" src="assets/icons/instr_2_0.svg" alt="RS Components">
                    <img class="instr_1" src="assets/icons/instr_2_1.svg" alt="RS Components">
                    <img class="instr_2" src="assets/icons/instr_2_2.svg" alt="RS Components">          
                    <img class="instr_3" src="assets/icons/instr_2_3.svg" alt="RS Components">
                </figure>
                <p class="top_padded">{{ $t('instructions.step_2.description') }}</p>
            </div>
            <div v-if="third_step" v-cloak>
                <h1>{{ $t('instructions.step_3.title') }}</h1>
                <figure class="inst_0">
                <img src="../../public/assets/icons/environments_intro.svg" class="enviro" style="width: 260px; left: 52%;">
                </figure>
                <p class="top_padded">{{ $t('instructions.step_3.description') }}</p>
            </div>
            <div v-if="fourth_step" v-cloak>
                <h1>{{ $t('instructions.step_4.title') }}</h1>
                <figure class="inst_0">
                    <img src="../../public/assets/icons/customise_character.svg" class="enviro fig_img_customise" style="height: 165px; left: 50%;">
                </figure>
                <p class="top_padded">{{ $t('instructions.step_4.description') }}</p>
            </div>
            <div v-if="complete" v-cloak>
                <h1 class="complete">{{ $t('game.congrats.title') }}</h1>
                <figure class="inst_0">
                    <img src="/assets/icons/thumbs_up_1.svg" class="enviro" style="height: 150px; left: 50%;" alt="" v-if="tone_0">
                    <img src="/assets/icons/thumbs_up_2.svg" class="enviro" style="height: 150px; left: 50%;" alt="" v-if="tone_1">
                    <img src="/assets/icons/thumbs_up_3.svg" class="enviro" style="height: 150px; left: 50%;" alt="" v-if="tone_2">
                    <img src="/assets/icons/thumbs_up_1.svg" class="enviro" style="height: 150px; left: 50%;" alt="" v-if="!tone_0 && !tone_1 && !tone_2">
                </figure>
                <p class="top_padded">{{ $t('game.congrats.description') }}</p>
                <div class="ready_dyk_img">
                    <img :src="ready_dyk_img" alt="">
                </div>
            </div>
            <div v-if="ready" v-cloak>
                <h1>{{ ready_title }}</h1>
                <figure class="inst_0">
                    <img :src="'/assets/environments/'+ready_image" v-cloak class="enviro" alt="">
                </figure>
                <p class="top_padded">{{ ready_description }}</p>
            </div>
            <div class="overlay_nav" v-if="!did_you_know" v-cloak>
                <ul class="overlay_progress" v-if="!ready && !customise_btn && !complete">
                    <li class="clicky" v-on:click="goToStep(1)" v-bind:class="{active: first_step || second_step || third_step || current_step === 1}"></li>
                    <li class="clicky" v-on:click="goToStep(2)" v-bind:class="{active: second_step || third_step}"></li>
                    <li class="clicky" v-on:click="goToStep(3)" v-bind:class="{active: third_step}"></li>
                </ul>
                    <p class="primary_btn noselect" v-on:click="nextStep(current_step)" v-html="customise_btn ? $t('buttons.customise_button') : $t('buttons.next_button')" v-if="!customise && !ready && !complete"></p>
                <router-link :to="congrats? '/thank-you' : '/ready/'+next_link" v-if="complete" class="primary_btn">
                    {{ $t('buttons.continue_button') }}
                </router-link>
                <router-link :to="{ name: 'game', params: {level: this.$route.params.level} }" v-if="ready" class="primary_btn">
                    {{ $t('buttons.get_started_button') }}
                </router-link>
                <p v-on:click="skip()" class="skip noselect" v-if="!ready && !complete && !fourth_step">{{ $t('buttons.skip_button') }}</p>
            </div>
        </div>
    </div>
</template>
<script>
import json from '@/main.json'
export default {
    name: 'AppGameInstructions',
    props: {
    beforeRouteEnter: {
      required: true,
      type: Object,
    },
    information: {
      required: true,
      type: Boolean,
    },
    did_you_know: {
      required: true,
      type: Boolean,
    },
    dyktitle: {
      required: true,
      type: String,
    },
    dykdescription: {
      required: true,
      type: String,
    },
    },
    data() {
        return {
            json,
            current_step: '',
            first_step: '',
            second_step: '',
            third_step: '',
            fourth_step: '',
            customise_btn: '',
            customise: false,
            ready: false,
            complete: false,
            congrats: false,
            ready_title: '',
            ready_image: '',
            ready_description: '',
            next_link: '',
            tone: '',
            tone_0: '',
            tone_1: '',
            tone_2: ''
        }
    },
    methods: {
        nextStep: function(currentStep) {
            // console.log('next');
            // console.log(currentStep);
            if(currentStep === 1){
                this.current_step = 2;
                this.second_step = true;
                this.first_step = false;
                this.third_step = false;
                this.fourth_step = false;
            }
            else if(this.second_step && currentStep === 2) {
                this.current_step = 3;
                this.second_step = false;
                this.first_step = false;
                this.third_step = true;
                this.fourth_step = false;
            }
            else if(this.third_step && currentStep === 3) {
                this.current_step = 4;
                this.second_step = false;
                this.first_step = false;
                this.third_step = false;
                this.fourth_step = true;
                this.customise_btn = true;
                this.information ? this.$router.push({ path: this.beforeRouteEnter.path }) : null;
            }
            else if(this.fourth_step && currentStep === 4) {
                this.customise = true;
                // this.controls = true;
                // this.first_step = false;
                // this.third_step = false;
                // this.fourth_step = false;
                // console.log(this.information);
                // console.log(this.beforeRouteEnter.path);
                this.$router.push({ path: `/customise` });
            }
            else {
                return null;
            }
            
        },
        goToStep: function(step) {
            // console.log('next');
            // console.log(step);
            if(step === 1){
                this.first_step == true;
                this.current_step = 1;
                this.second_step = false;
                this.third_step = false;
                this.fourth_step = false;
                this.customise_btn = false;
                this.customise = false;
            }
            else if(step === 2) {
                this.current_step = 2;
                this.second_step = true;
                this.first_step = false;
                this.third_step = false;
                this.fourth_step = false;
                this.customise_btn = false;
            }
            else if(step === 3) {
                this.current_step = 3;
                this.second_step = false;
                this.first_step = false;
                this.third_step = true;
                this.fourth_step = false;
                this.customise_btn = false;
            }
            else {
                return null;
            }
            
        },
        skip: function(){
            if(this.information){
                this.$router.push({ path: this.beforeRouteEnter.path });
            }
            else {
                this.current_step = 4;
                this.second_step = false;
                this.first_step = false;
                this.third_step = false;
                this.fourth_step = true;
                this.customise_btn = true;
            }
        },
        setTextAndLinks: function(level){
            this.ready_title = this.$t('game.'+level+'.ready_title');
            this.ready_image = this.$t('game.'+level+'.ready_image');
            this.ready_description = this.$t('game.'+level+'.description');
            this.ready_dyk_img = this.$t('game.'+level+'.dyk_img');

            switch(level){
                case 'logistics':
                this.next_link = 'lab';
                break;
                case 'lab':
                this.next_link = 'construction';
                break;
                case 'construction':
                this.next_link = 'thank-you';
                this.congrats = true;
                break;
            }
        }
    },
    beforeMount() {
        this.setTextAndLinks(this.$route.params.level);

        this.current_step = 1;
        this.first_step = true;
        this.second_step = false;
        this.third_step = false;
        this.$route.name === 'ready' ? (this.complete = false) : null;
        this.$route.name === 'ready' ? (this.ready = true) && (this.first_step = false) : null;
        this.$route.name === 'complete' ? (this.complete = true) && (this.first_step = false) && (this.ready = false) : null;
        this.$route.name === 'ready' ? this.current_step = null : null;
        this.$route.name === 'complete' ? this.current_step = null : null;
        this.tone = localStorage.getItem('characterTone');
        this.tone === 'tone-0'? this.tone_0 = true : null;
        this.tone === 'tone-1'? this.tone_1 = true : null;
        this.tone === 'tone-2'? this.tone_2 = true : null;
    },
    mounted() {
        // console.log(this.beforeRouteEnter);
        // console.log(this.information);
    },
    watch: {
      $route(to) {
        // console.log(to);
        // console.log(from);
        to.name === 'ready' ? (this.current_step = null) : null;
        to.name === 'complete' ? (this.current_step = null) : null;
        to.name === 'ready' ? (this.complete = false) : null;
        to.name === 'ready' ? (this.ready = true) && (this.first_step = false) : null;
        to.name === 'complete' ? (this.complete = true) : null;
        to.name === 'complete' ? (this.ready = false) : null;
        to.name === 'ready' ? (this.setTextAndLinks(this.$route.params.level)) : null;
        to.name === 'complete' ? (this.setTextAndLinks(this.$route.params.level)) : null;
      }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .skip {
        text-decoration: underline;
        cursor: pointer;
    }
    .complete {
        font-size: 40px;
    }
    .clicky {
        cursor: pointer;
    }
    .close_icon {
        position: relative;
        left: calc(76% - 120px);
    }
    .fig_img_env {
        display: block;
        left: calc(15% - 50px);
        position: relative;
        height: auto;
    }
    .fig_img_customise {
        display: block;
        left: calc(50% - 75px);
        position: relative;
        width: 150px;
        height: 162px;
        bottom: 5px;
    }
    .enviro{
        margin: 0;
        position: absolute;
        top: 62%;
        left: 54%;
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        position: relative;
        width: 230px;
        height: 230px;
    }
    .complete_svg {
        left: calc(53% - 120px);
        position: absolute;
        width: 150px;
        top: calc(42% - 120px);
        height: 150px;
        bottom: 100px;
    }
    .noselect {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
         -khtml-user-select: none; /* Konqueror HTML */
           -moz-user-select: none; /* Old versions of Firefox */
            -ms-user-select: none; /* Internet Explorer/Edge */
                user-select: none; /* Non-prefixed version, currently
                                      supported by Chrome, Opera and Firefox */
    }
    .ready_dyk_img img {
        width: 350px;
    }
</style>